<template>
    <div class="row">
        <div class="col-12">
            <div class="float-right mb-2" v-if="isAdmin">
                <router-link class="btn btn-danger btn-sm" :to="{ name: 'parts_import' }">
                    <i class="fas fa-file-import fa-fw"></i> {{ $t('part.button.import') }}
                </router-link>
            </div>
            <div class="clearfix"></div>
            <card>
                <div class="card-body">
                    <div class="mb-4">
                        <label class="text-uppercase px-1 mb-0 text-muted">
                            <small>{{$t('part.text.showcategory')}}:</small>
                        </label>
                        <a
                            @click.prevent="onFilterSet"
                            class="btn btn-xs btn-primary px-1 mr-1 mb-1"
                            href
                            data-category-id="all"
                            :disabled="options.params.category == 'all'"
                        >All</a>
                        <slot v-for="category in categories">
                            <a
                                @click.prevent="onFilterSet"
                                class="btn btn-xs btn-primary px-1 mr-1 mb-1"
                                href
                                :data-category-id="category.id"
                                :disabled="options.params.category == category.id"
                            >{{$t('part.categories.' + category.name.toLowerCase())}}</a>
                        </slot>

                        <div class="float-right" v-if="isAdmin">
                          <button class="btn btn-secondary btn-sm" @click="export2Excel">
                            <i class="fas fa-download fa-fw"></i> {{ $t('part.button.export_catalog') }}
                          </button>
                        </div>

                    </div>

                    <v-server-table
                        ref="vuetable"
                        url="/dtable/parts"
                        :columns="columns"
                        :options="options"
                    >
                        <template slot="beforeFilter">
                            <h2>
                                <i class="fas fa-cogs text-primary"></i> {{$t('part.title')}}
                            </h2>
                        </template>
                        <template slot="afterLimit">
                            <router-link class="btn btn-primary ml-2" :to="{ name: 'parts_new' }">
                                <i class="fas fa-plus fa-fw"></i> {{$t('part.button.addnew')}}
                            </router-link>
                        </template>
                        <template slot="id" slot-scope="props" class="btn-group" role="group"  v-if="isAdminRole">
                            <router-link
                                class="btn btn-xs btn-primary mr-1"
                                :to="{ name: 'parts_edit', params: { id: props.row.id } }"
                            >
                                <i class="fas fa-edit fa-fw"></i>
                            </router-link>
                            <router-link
                                class="btn btn-xs btn-primary mr-1"
                                :to="{ name: 'parts_delete', params: { id: props.row.id } }"
                            >
                                <i class="fas fa-trash-alt fa-fw"></i>
                            </router-link>
                        </template>
                        <template slot="updated_at" slot-scope="props">
                          {{ convertToGMT3(props.row.created_at) }}
                        </template>
                    </v-server-table>
                </div>
            </card>
        </div>
    </div>
</template>
<script>
import $http from "@/helpers/api";
export default {
  data() {
    return {
      columns: ["sku", "name", "code", "img", "created_at", "updated_at", "id"],
      options: {
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          sku: () => this.$t('field.sku'),
          name: () => this.$t('field.name'),
          code: () => this.$t('field.code'),
          img: () => this.$t('field.image'),
          created_at: () => this.$t('field.createdat'),
          updated_at: () => this.$t('field.last_update'),
          id: ""
        },
        texts: {
          count: this.$t('field.count'),
          filter: this.$t('field.filter'),
          filterPlaceholder: this.$t('field.filterplaceholder'),
          limit: this.$t('field.limit'),
        },
        orderBy: {
          ascending: false,
          column: "sku"
        },
        columnsClasses: { id: "text-right" },
        skin: "table table-sm table-hover",
        pagination: {
          edge: true
        },
        params: {
          category: "all"
        },
        sortIcon: {
          base: "fas fa-sort",
          up: "fas fa-sort-up",
          down: "fas fa-sort-down",
          is: "fas fa-sort"
        }
      }
    };
  },
  computed: {
    isAdminRole() {
      return this.$store.getters["auth/isInRoles"]("admin");
    },
    isAdmin() {
      return this.$store.getters["auth/getIsAdmin"];
    },
    categories() {
      return this.$store.getters["parts/getCategories"];
    }
  },
  methods: {
    reduceDate(dateStr) {
      return dateStr.substring(2, 4) + dateStr.substring(5, 7) + dateStr.substring(8, 10);
    },
    onFilterSet(e) {
      this.options.params.category = e.target.getAttribute("data-category-id");
      this.$nextTick(() => {
        this.$refs.vuetable.refresh();
      });
    },
    convertToGMT3(dateString) {
      if (!dateString) return "";

      const date = new Date(dateString);
      const offset = -1; // GMT-3
      date.setHours(date.getHours() + offset);

      const day = ('0' + date.getDate()).slice(-2);
      const month = ('0' + (date.getMonth() + 1)).slice(-2);
      const year = date.getFullYear();
      const hours = ('0' + date.getHours()).slice(-2);
      const minutes = ('0' + date.getMinutes()).slice(-2);
      const seconds = ('0' + date.getSeconds()).slice(-2);

      return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
    },
    getCurrentDate(){
      var myDate = new Date();
      var month = ('0' + (myDate.getMonth() + 1)).slice(-2);
      var day = ('0' + myDate.getDate()).slice(-2);
      var year = myDate.getFullYear();
      return year + '-' + month + '-' + day;
    },
    export2Excel() {
      let filename = 'PARTS_' + this.getCurrentDate();

      const tHeader = [
        "SKU",
        "NAME",
        "CODE",
        "PRICE",
        "CREATED_AT",
        "UPDATED_AT",
        "ID"
      ];

      const filterVal = [
        "SKU",
        "NAME",
        "CODE",
        "PRICE",
        "CREATED_AT",
        "UPDATED_AT",
        "ID"
      ];

      const url = "/dtable/parts_export";

      $http.get(url).then(resp => {
        this.exportData = {
          data: resp.data
        }

        // console.log(this.exportData.data);
        import('@/excel/Export2Excel').then(excel => {

          const list = this.exportData.data;  //Save tableData in data to list
          const data = this.formatJson(filterVal, list);

          excel.export_json_to_excel({
            header: tHeader, //Header Required
            data, //Specific data Required
            filename: filename, //Optional
            autoWidth: true, //Optional
            bookType: 'xlsx' //Optional
          })
        })
        .catch(error => {
          console.log(error);
          this.notify("An error occurred!");
        });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j] !== undefined ? v[j] : ''));
    }
  },
  created() {
    this.$store.dispatch("parts/getCategories");
  }
};
</script>
<style></style>
